import { rem } from 'polished'
import styled from 'styled-components'

import type { EllipsisMenuProps } from './common'

import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'

export const ModalMenuContent = styled.div`
  padding-inline: ${rem(8)};
`

export default function MenuModal(props: EllipsisMenuProps) {
  const { title, subtitle, bodyContent, footerContent } = props
  const { closeModal, goBack } = useModalCallbacks()

  return (
    <>
      <ModalHeader
        title={title}
        subtitle={subtitle}
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <ModalBody>
        <ModalMenuContent>{bodyContent}</ModalMenuContent>
      </ModalBody>
      <ModalFooter>{footerContent}</ModalFooter>
    </>
  )
}
